export default "__VITE_ASSET__9pJZhS9C__"